
import React from "react";
import { Button } from 'react-bootstrap';
import CsLineIcons from '../../cs-line-icons';

import Item from "./item";

class ConditionalDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.onDocumentMouseDown);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.onDocumentMouseDown);
    }

    onDocumentMouseDown = (e) => {
        if (!this.state.show) return;
        if (this.wrapperRef.current?.contains(e.target)) return;
        this.setState({ show: false });
    }

    onToggleClick = () => {
        if (!this.props.enabled) return;
        this.setState((prev) => ({ show: !prev.show }));
    }

    onItemClick = () => {
        this.setState({ show: false });
    }

    get buttonClassName() {
        if (this.props.buttonClassName) return this.props.buttonClassName;
        return this.props.icon
            ? "dropdown-toggle btn-icon btn-icon-start w-100 w-md-auto"
            : "dropdown-toggle w-100 w-md-auto";
    }

    render() {
        if (this.props.display)
        {
            const variant = this.props.enabled ? (this.props.enabledVariant || "primary") : (this.props.disabledVariant || "secondary");
            return (
                <div ref={this.wrapperRef} className={`dropdown d-inline-block position-relative ${this.props.className || ""}`}>
                    <Button
                        type="button"
                        variant={variant}
                        disabled={!this.props.enabled}
                        className={this.buttonClassName}
                        aria-expanded={this.state.show}
                        aria-haspopup="menu"
                        onClick={this.onToggleClick}
                    >
                        {this.props.icon ? <CsLineIcons icon={this.props.icon} /> : null}
                        <span>{this.props.children}</span>
                    </Button>
                    <div
                        className={`dropdown-menu dropdown-menu-end shadow-sm${this.state.show ? " show" : ""} ${this.props.menuClassName || ""}`}
                        role="menu"
                        style={{ minWidth: this.props.minWidth || "13rem" }}
                    >
                    {this.props.items?.map((item, index) => {
                        return (
                            <Item key={`dditem.${index}`} {...item} index={index} onAfterClick={this.onItemClick} />
                        );
                    })}
                    </div>
                </div>
            )
        }
        return null;
    }
}

ConditionalDropdown.defaultProps = {
    enabled: true,
};

export default ConditionalDropdown;
